import { RootState } from '../../../ts/types/state';

/**
 * Selector to get the sidebar state
 * @param state - The root Redux state
 * @returns The sidebar state object
 */
export const selectSidebar = (state: RootState) => state.sidebar;

/**
 * Selector to get the open sidebar content
 * @param state - The root Redux state
 * @returns The content of the currently open sidebar, or null if closed
 */
export const selectOpenSidebar = (state: RootState) => state.sidebar.content;

/**
 * Selector to check if sidebar is open
 * @param state - The root Redux state
 * @returns True if sidebar has content (is open), false if closed
 */
export const selectIsSidebarOpen = (state: RootState) => state.sidebar.content !== null;

export const selectSidebarMeta = (state: RootState) => state.sidebar.meta;
